import { render, staticRenderFns } from "./CalmIcon.vue?vue&type=template&id=536f7d01&"
import script from "./CalmIcon.vue?vue&type=script&lang=js&"
export * from "./CalmIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports